export const environment = {
  production: true,
  baseUrl: "https://portal.energy4living.com.au/backend/api",
};
